import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-288">
      <Header data-id="element-289" />
      <main className="flex-grow" data-id="element-290">
        <Outlet data-id="element-291" />
      </main>
      <Footer data-id="element-292" />
    </div>;
}